import { PatientEncounter } from "@finpay-development/shared-platform/lib/esm/patient/components/models/patient-encounter";
import {
  emptyPatientEncounterCard,
  PatientEncounterCard,
} from "@finpay-development/shared-platform/lib/esm/patient/components/models/patient-encounter-card";
import { emptyContactCard } from "@finpay-development/shared-platform/lib/esm/patient/components/models/contact-card";
import { emptyWorkflow } from "@finpay-development/shared-platform/lib/esm/shared/model/client";
import { emptyPayorRisk, emptyTimingRisk } from "@finpay-development/shared-platform/lib/esm/shared/model/timing-and-payor-risk";
import { emptyRiskClass } from "@finpay-development/shared-platform/lib/esm/shared/model/risk-class";
import { emptyTypeOfCare } from "@finpay-development/shared-platform/lib/esm/shared/model/type-of-care";
import { StatusColors } from "@finpay-development/shared-platform/lib/esm/shared/enums";

/** Contact shape from GET /v2/encounter/{id}/contact (or similar). */
export interface EncounterContactName {
  contactId?: number;
  title?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  primPhoneNum?: string;
}

/**
 * Full PE by-id DTO does not include patient.contact / patientContactInfo.
 * IOC card APIs embed contactCard from patient.contact — pass contact separately.
 */
export function mapPeToCard(
  pe: PatientEncounter,
  contact?: EncounterContactName | null
): PatientEncounterCard {
  return {
    ...emptyPatientEncounterCard,
    patientId: pe.patientId,
    patientEncounterId: pe.patientEncounterId,
    contactCard: {
      ...emptyContactCard,
      contactId: contact?.contactId || 0,
      title: contact?.title || "",
      firstName: contact?.firstName || "",
      middleName: contact?.middleName || "",
      lastName: contact?.lastName || "",
      email: contact?.email || "",
      primPhoneNumber: contact?.primPhoneNum || "",
    },
    createDt: pe.createDt || pe.instanceCreateDt,
    clientId: pe.clientId,
    clientFacilityId: pe.facilityId,
    clientName: pe.clientName || pe.client?.clientName || "",
    clientFacilityName: pe.facilityName || "",
    workflow: pe.workflow || emptyWorkflow,
    admissionDt: pe.admissionDt || "",
    dischargeDt: pe.dischargeDt || "",
    cardColor: StatusColors.gray,
    finClearanceStatus: pe.finClearanceStatus || "",
    timingRisk: pe.timingRisk || emptyTimingRisk,
    payorRisk: pe.payorRisk || emptyPayorRisk,
    riskClass: pe.riskClass || emptyRiskClass,
    typeOfCare: pe.typeOfCare || emptyTypeOfCare,
    pfrAmt: pe.pfrAmt || 0,
  };
}
